import $ from 'jquery';

const schimmelpfennigBecke = () => {
  // Ansprechpartner-Suche einblenden
  $('#ansprechpartner-button').mouseover(() => {
    $('.ansprechpartner-suche').fadeIn('fast');
  });

  $('.ansprechpartner-suche').mouseleave(e => {
    const indexHeader = $('.themengebiet-header').prop('selectedIndex');
    if (indexHeader === 0) {
      if (e.relatedTarget !== null) {
        $('.ansprechpartner-suche').fadeOut('fast', () => {});
      }
    }
  });

  $('.c-main-nav__link').mouseover(() => {
    $('.ansprechpartner-suche').fadeOut('fast', () => {
      // Animation complete
    });
  });

  /* Dritte Navigationsebene einblenden
    $(".c-main-nav__subitem").mouseover(function () {
        $(".subdropdown").fadeIn( "fast", function() {
            // Animation complete
        });
    }); */

  // Publikationen Details einblenden

  $('.publikationen-kachel').on('click', '.display-pub-details', function() {
    $(this)
      .next('.small-pub-details')
      .toggleClass('hidden');
  });

  $('.urekoKachel').on('click', '.display-ureko-details', function() {
    $(this)
      .parents('.urekoKachel')
      .next('.ureko-details-mobile')
      .toggleClass('hidden');
  });

  /* --------------------------------------------- */
  /*           MOBILE-BURGER-NAVIGATION            */
  /* --------------------------------------------- */

  // Burger-Navigation ausklappen
  $('.header').on('click', '.hitbox', () => {
    $('.mobile-nav').toggleClass('hidden');
    $('body, html').toggleClass('stuck');
    $('.c-main-nav-m').toggleClass('nav-scroll');
    $('.ansprechpartner-suche-mobile').toggleClass('nav-scroll');
    $('.hamburger-line').toggleClass('hamburger-animation');
  });

  let secondTitle = null;

  // Zweite navigationsebene einblenden
  $('.c-main-nav-m').on('click', '.c-main-nav-link-m', function() {
    secondTitle = $(this).text();
    console.log(secondTitle);
    $(this)
      .next('.c-main-nav-dropdown-m')
      .css('transform', 'translateX(0%)');
  });

  // Zweite navigationsebene ausblenden
  $('.c-main-nav-dropdown-m').on('click', '.back-m', function() {
    $(this)
      .parent('.c-main-nav-dropdown-m')
      .css('transform', 'translateX(100%)');
  });

  // Dritte Navigationsebene einblenden
  $('.c-main-nav-dropdown-m').on('click', '.c-main-nav-sublink-m', function() {
    $('.back_title').replaceWith(secondTitle);
    console.log(secondTitle);
    $(this)
      .next('.subdropdown-m')
      .css('transform', 'translateX(0%)');
  });

  // Dritte navigationsebene ausblenden
  $('.subdropdown-m').on('click', '.sub-back-m', function() {
    $(this)
      .parent('.subdropdown-m')
      .css('transform', 'translateX(100%)');
  });

  // Ansprechpartner-Suche ausklappen
  $('.header').on('click', '#ansprechpartner-button-mobile', () => {
    $('.ansprechpartner-suche-mobile').toggleClass('hidden');
  });

  // TranslateX
  $(document).ready(() => {
    $('.layeranimation').each(() => {
      // var activeColor = $(this).attr('id');
      $('.layeranimation').addClass('translateX');
    });
  });

  $(document).ready(() => {
    $('.heading-subline').each(() => {
      $('.heading-subline').addClass('move-up');
    });
  });

  /* --------------------------------------------- */
  /*           ANSPRECHPARTNER-FILTER              */
  /* --------------------------------------------- */

  // Hide all Subcategory Dropdowns and disable Submit Button on default
  $('.subcategory-dropdown').hide();
  $('.subcategory-dropdown-disabled').prop('disabled', 'disabled');
  $('#partner-submit').prop('disabled', true);
  $('#partner-submit').addClass('button-disabled');

  // Build URL
  $('.themengebiet-header').change(() => {
    $('.subcategory-dropdown').hide();
    $('.subcategory-dropdown-disabled').hide();

    const index = $('.themengebiet-header').prop('selectedIndex');

    $('.themengebiet-header').removeAttr('id');
    $('.themengebiet-header').attr('id', 'thema');

    $('.subcategory-dropdown').removeAttr('id');
    $(`.subcategory-dropdown:nth-child(${index + 1})`).attr('id', 'leistung');
    $(`.subcategory-dropdown:nth-child(${index + 1})`).show();

    const partnerFields = ['thema', 'leistung'];
    const partnerSelect = {};

    // Show disabled Subcategory Dropdown
    if ($('.themengebiet-header').prop('selectedIndex') === 0) {
      $('.subcategory-dropdown-disabled').show();
    }

    function buildParameters() {
      $.each(partnerFields, function() {
        if ($(`#${this}`).prop('selectedIndex') > 0) {
          partnerSelect[this] = $(`#${this} option`)
            .filter(':selected')
            .text();
        }
      });
      return partnerSelect;
    }

    $.each(partnerFields, function() {
      $(`#${this}`).change(() => {
        buildParameters(partnerFields);
      });
    });

    // Enable or disable submit button
    $('#leistung').change(() => {
      if ($('#leistung').prop('selectedIndex') > 0) {
        $('#partner-submit').prop('disabled', false);
        $('#partner-submit').removeClass('button-disabled');
      } else {
        $('#partner-submit').prop('disabled', true);
        $('#partner-submit').addClass('button-disabled');
      }
    });

    $('.themengebiet-header').change(() => {
      if ($('#leistung').prop('selectedIndex') > 0) {
        $('#partner-submit').prop('disabled', false);
        $('#partner-submit').removeClass('button-disabled');
      } else {
        $('#partner-submit').prop('disabled', true);
        $('#partner-submit').addClass('button-disabled');
      }
    });

    // Load url
    $('#partner-submit').click(() => {
      window.history.replaceState(null, null, window.location.pathname);
      window.location.replace(
        `https://ureko.de/suchausgabe/?${$.param(partnerSelect)}`,
      );
    });
  });

  /* --------------------------------------------- */
  /*        ANSPRECHPARTNER-FILTER-MOBILE          */
  /* --------------------------------------------- */

  // Hide all Subcategory Dropdowns and disable Submit Button on default
  $('.subcategory-dropdown-mobile').hide();
  $('.subcategory-dropdown-disabled-mobile').prop('disabled', 'disabled');
  $('#partner-submit').prop('disabled', true);
  $('#partner-submit').addClass('button-disabled');

  // Build URL
  $('.themengebiet-mobile').change(() => {
    $('.subcategory-dropdown-mobile').hide();
    $('.subcategory-dropdown-disabled-mobile').hide();

    const index = $('.themengebiet-mobile').prop('selectedIndex');

    $('.themengebiet-mobile').removeAttr('id');
    $('.themengebiet-mobile').attr('id', 'thema');

    $('.subcategory-dropdown-mobile').removeAttr('id');
    $(`.subcategory-dropdown-mobile:nth-child(${index + 1})`).attr(
      'id',
      'leistung',
    );
    $(`.subcategory-dropdown-mobile:nth-child(${index + 1})`).show();

    const partnerFields = ['thema', 'leistung'];
    const partnerSelect = {};

    // Show disabled Subcategory Dropdown
    if ($('.themengebiet-mobile').prop('selectedIndex') === 0) {
      $('.subcategory-dropdown-disabled-mobile').show();
    }

    function buildParameters() {
      $.each(partnerFields, function() {
        if ($(`#${this}`).prop('selectedIndex') > 0) {
          partnerSelect[this] = $(`#${this} option`)
            .filter(':selected')
            .text();
        }
      });
      return partnerSelect;
    }

    $.each(partnerFields, function() {
      $(`#${this}`).change(() => {
        buildParameters(partnerFields);
      });
    });

    // Enable or disable submit button
    $('#leistung').change(() => {
      if ($('#leistung').prop('selectedIndex') > 0) {
        $('#partner-submit-mobile').prop('disabled', false);
        $('#partner-submit-mobile').removeClass('button-disabled');
      } else {
        $('#partner-submit-mobile').prop('disabled', true);
        $('#partner-submit-mobile').addClass('button-disabled');
      }
    });

    $('.themengebiet-mobile').change(() => {
      if ($('#leistung').prop('selectedIndex') > 0) {
        $('#partner-submit-mobile').prop('disabled', false);
        $('#partner-submit-mobile').removeClass('button-disabled');
      } else {
        $('#partner-submit-mobile').prop('disabled', true);
        $('#partner-submit-mobile').addClass('button-disabled');
      }
    });

    // Load url
    $('#partner-submit-mobile').click(() => {
      window.history.replaceState(null, null, window.location.pathname);
      window.location.replace(
        `https://ureko.de/suchausgabe/?${$.param(partnerSelect)}`,
      );
    });
  });

  /* --------------------------------------------- */
  /*        ANSPRECHPARTNER-FILTER-BILDBUEHNE      */
  /* --------------------------------------------- */

  // Hide all Subcategory Dropdowns and disable Submit Button on default
  $('.subcategory-dropdown-bildbuehne').hide();
  $('.subcategory-dropdown-disabled-bildbuehne').prop('disabled', 'disabled');
  $('#partner-submit-bildbuehne').prop('disabled', true);
  $('#partner-submit-bildbuehne').addClass('button-disabled');

  // Build URL
  $('.themengebiet').change(() => {
    $('.subcategory-dropdown-bildbuehne').hide();
    $('.subcategory-dropdown-disabled-bildbuehne').hide();

    const index = $('.themengebiet').prop('selectedIndex');

    $('.themengebiet').removeAttr('id');
    $('.themengebiet').attr('id', 'thema');

    $('.subcategory-dropdown-bildbuehne').removeAttr('id');
    $(`.subcategory-dropdown-bildbuehne:nth-child(${index + 1})`).attr(
      'id',
      'leistung',
    );
    $(`.subcategory-dropdown-bildbuehne:nth-child(${index + 1})`).show();

    const partnerFields = ['thema', 'leistung'];
    const partnerSelect = {};

    // Show disabled Subcategory Dropdown
    if ($('.themengebiet').prop('selectedIndex') === 0) {
      $('.subcategory-dropdown-disabled-bildbuehne').show();
    }

    function buildParameters() {
      $.each(partnerFields, function() {
        if ($(`#${this}`).prop('selectedIndex') > 0) {
          partnerSelect[this] = $(`#${this} option`)
            .filter(':selected')
            .text();
        }
      });
      return partnerSelect;
    }

    $.each(partnerFields, function() {
      $(`#${this}`).change(() => {
        buildParameters(partnerFields);
      });
    });

    // Enable or disable submit button
    $('#leistung').change(() => {
      if ($('#leistung').prop('selectedIndex') > 0) {
        $('#partner-submit-bildbuehne').prop('disabled', false);
        $('#partner-submit-bildbuehne').removeClass('button-disabled');
      } else {
        $('#partner-submit-bildbuehne').prop('disabled', true);
        $('#partner-submit-bildbuehne').addClass('button-disabled');
      }
    });

    $('.themengebiet').change(() => {
      if ($('#leistung').prop('selectedIndex') > 0) {
        $('#partner-submit-bildbuehne').prop('disabled', false);
        $('#partner-submit-bildbuehne').removeClass('button-disabled');
      } else {
        $('#partner-submit-bildbuehne').prop('disabled', true);
        $('#partner-submit-bildbuehne').addClass('button-disabled');
      }
    });

    // Load url
    $('#partner-submit-bildbuehne').click(() => {
      window.history.replaceState(null, null, window.location.pathname);
      window.location.replace(
        `https://ureko.de/suchausgabe/?${$.param(partnerSelect)}`,
      );
    });
  });

  /* --------------------------------------------- */
  /*                   READ-MORE                   */
  /* --------------------------------------------- */

  // function AddReadMore() {
  //   // This limit you can set after how much characters you want to show Read More.
  //   const carLmt = 300;
  //   // Text to show when text is collapsed
  //   const readMoreTxt = ' Mehr lesen ';
  //   // Text to show when text is expanded
  //   const readLessTxt = ' Weniger ';
  //
  //   // Traverse all selectors with this class and manupulate HTML part to show Read More
  //   $('.addReadMore').each(function() {
  //     if ($(this).find('.firstSec').length) return;
  //
  //     const allstr = $(this).text();
  //     if (allstr.length > carLmt) {
  //       const firstSet = allstr.substring(0, carLmt);
  //       const secdHalf = allstr.substring(carLmt, allstr.length);
  //       const strtoadd = `${firstSet}<span class='SecSec'>${secdHalf}</span><span class='readMore' title='Click to Show More'>${readMoreTxt}</span><span class='readLess' title='Click to Show Less'>${readLessTxt}</span>`;
  //       $(this).html(strtoadd);
  //     }
  //   });
  //   // Read More and Read Less Click Event binding
  //   $(document).on('click', '.readMore,.readLess', function() {
  //     $(this)
  //       .closest('.addReadMore')
  //       .toggleClass('showlesscontent showmorecontent');
  //   });
  // }
  // $(() => {
  //   // Calling function after Page Load
  //   AddReadMore();
  // });

  // function AddReadmore() {
  //   if ($('.news-beitrag').height() > 380) {
  //     $(this)
  //   }
  // }

  $('.addReadMore').each(function() {
    if ($(this).height() > 320) {
      $(this)
        .next('.readmore-button')
        .removeClass('hidden');
    }
  });

  $(document).on('click', '.readmore-button', function() {
    $(this).toggleClass('readless-button');
    $(this)
      .closest('.news-beitrag')
      .toggleClass('news-beitrag-expand');
    $(this)
      .children('button')
      .text(
        (i, text) => (text === 'Mehr lesen' ? 'Weniger lesen' : 'Mehr lesen'),
      );
  });

  /* --------------------------------------------- */
  /*              PUBLIKATIONEN-FILTER             */
  /* --------------------------------------------- */

  const selectFields = ['themengebiet', 'autor', 'jahr', 'pdf'];

  const urlSelect = {};

  function buildParams() {
    $.each(selectFields, function() {
      if ($(`#${this}`).prop('selectedIndex') > 0) {
        urlSelect[this] = $(`#${this} option`)
          .filter(':selected')
          .text();
      }

      if ($(`#pdf`).is(':checked')) {
        urlSelect.pdf = true;
        console.log(this);
      } else {
        urlSelect.pdf = null;
      }
    });
    return urlSelect;
  }

  $.each(selectFields, function() {
    $(`#${this}`).change(() => {
      buildParams(selectFields);
      console.log(urlSelect);
    });
  });

  $('#filter-submit').click(() => {
    window.history.replaceState(null, null, window.location.pathname);
    window.location.replace(`${document.location.href}?${$.param(urlSelect)}`);
  });

  // TranslateX
  $.fn.isInViewport = function isInViewport() {
    const elementTop = $(this).offset().top;
    const elementBottom = elementTop + $(this).outerHeight();

    const viewportTop = $(window).scrollTop();
    const viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  /* --------------------------------------------- */
  /*        PUBLIKATIONEN / VORTRÄGE SWITCH        */
  /* --------------------------------------------- */

  /* Wenn es nur ENTWEDER Vorträge ODER Publikationen gibt */

  const vortraege = $('p.vortraege-switch');
  const publikationen = $('p.publikationen-switch');

  if (!$.contains(document, vortraege[0])) {
    console.log('Publikationen da');
    $('.vortraege-switcher').addClass('hidden');
    $('.publikationen-switch').addClass('publikationen-vortraege-active');
    $('.publikationen-switcher').removeClass('hidden');
  }

  if (!$.contains(document, publikationen[0])) {
    console.log('Vorträge da');
    $('.publikationen-switcher').addClass('hidden');
    $('.vortraege-switch').addClass('publikationen-vortraege-active');
    $('.vortraege-switcher').removeClass('hidden');
  }

  /* Wenn es Vorträge UND Publikationen gibt */

  $('.publikationen-switch').addClass('publikationen-vortraege-active');

  $('.publikationen-vortraege-switch').on(
    'click',
    '.publikationen-switch',
    () => {
      $('.vortraege-switch').removeClass('publikationen-vortraege-active');
      $('.publikationen-switcher').removeClass('hidden');
      $('.vortraege-switcher').addClass('hidden');

      $('.publikationen-switch').addClass('publikationen-vortraege-active');
    },
  );

  $('.publikationen-vortraege-switch').on('click', '.vortraege-switch', () => {
    $('.publikationen-switch').removeClass('publikationen-vortraege-active');
    $('.publikationen-switcher').addClass('hidden');
    $('.vortraege-switcher').removeClass('hidden');

    $('.vortraege-switch').addClass('publikationen-vortraege-active');
  });

  /* --------------------------------------------- */
  /*                   NAV DELAY                   */
  /* --------------------------------------------- */

  $('.c-main-nav__item')
    .find('.c-main-nav__link')
    .on('mouseenter', function() {
      const navItem = this;
      $('.c-main-nav__item')
        .find('.c-main-nav__dropdown')
        .removeClass('flex');
      $(navItem)
        .next('.c-main-nav__dropdown')
        .addClass('flex');
      $(navItem).removeClass('focus-black');
      $(navItem).addClass('focus-red');
    });

  $('.c-main-nav__item')
    .find('.c-main-nav__dropdown')
    .on('mouseleave', function() {
      const navItem = this;
      $(navItem).removeClass('flex');

      $(navItem)
        .parent()
        .find('.c-main-nav__link')
        .removeClass('focus-red');
      $(navItem)
        .parent()
        .find('.c-main-nav__link')
        .addClass('focus-black');
    });

  /* --------------------------------------------- */
  /*                   SCROLL-DOWN                 */
  /* --------------------------------------------- */
  function scrollDown() {
    const vheight = $(window).height();
    $('html, body').animate(
      {
        scrollTop: (Math.floor($(window).scrollTop() / vheight) + 1) * vheight,
      },
      500,
    );
  }

  $('.scroll-down').click(event => {
    scrollDown();
    event.preventDefault();
  });

  $('.einstieg-small')
    .first()
    .on('click', 'a', () => {
      console.log('funzt');
      $('.foobox img')
        .first()
        .trigger('click');
    });

  /* --------------------------------------------- */
  /*                 MAIL TOOLTIPP                 */
  /* --------------------------------------------- */

  // $('.person-kontakt a').mouseover(() => {
  //   $('.mail-tooltip').addClass("hidden");
  // });

  $('.person-kontakt').on('mouseover', '.tooltip-toggle', function() {
    $(this)
      .next('.mail-tooltip')
      .fadeIn(300);
  });

  $('.sachverstaendigeDescription').on('mouseleave', () => {
    $('.mail-tooltip')
      .delay(500)
      .fadeOut(300);
  });

  $('.person-kontakt-full').on('mouseover', '.tooltip-toggle', function() {
    $(this)
      .next('.mail-tooltip')
      .fadeIn(300);
  });

  $('.sachverstaendige-description-full').on('mouseleave', () => {
    $('.mail-tooltip')
      .delay(500)
      .fadeOut(300);
  });

  /* --------------------------------------------- */
  /*           SHOW-HEADER-ON-SCROLL-UP            */
  /* --------------------------------------------- */
  $(document).ready(() => {
    let c;
    let currentScrollTop = 0;
    const navbar = $('.header-container');

    $(window).scroll(() => {
      const a = $(window).scrollTop();
      const b = navbar.height();

      currentScrollTop = a;

      if (c < currentScrollTop && a > b + b) {
        navbar.addClass('scrollUp');
      } else if (c > currentScrollTop && !(a <= b)) {
        navbar.removeClass('scrollUp');
      }
      c = currentScrollTop;
    });
  });

  $('.einstieg-small a[data-check="#galerie"]').on('click', () => {
    $('a.versuche button')
      .eq(0)
      .click();
  });
};

export default schimmelpfennigBecke;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/schimmelpfennig-becke-chisel/src/scripts/modules/schimmelpfennig-becke.js